import { NullQ } from "@pdfking/structs"
import { KeyDrop } from "@pdfking/tfunc"

import type { GrowKind, GrowTemplate } from "#public"
import { GrowLayoutSize, PAGE_ITSELF } from "#public"

/** The template as data: its tree over the symbols, summed to one length
 * per axis — what the pricing and Python read. The page itself grows
 * nothing: the pricing must see nothing (`has_grow`). */
export const CompileGrow = (template: GrowTemplate): GrowKind => {
  const size = template.layout === PAGE_ITSELF ? undefined : GrowLayoutSize(template.layout)
  return {
    ...KeyDrop(template, ["layout"]),
    opening_grow: NullQ(size) ? [] : [size.along],
    reverse_grow: NullQ(size) ? [] : [size.across],
  }
}
